// extracted by mini-css-extract-plugin
export default {"modal":"UploadQuestionsErrorTheatre_modal__O7QrV"};